import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

import { scrollToRef } from 'shared/functions';
import { getNewsFeedPreferencesIsPending, getNewsFeedShouldRefresh } from 'selectors/common';
import { useQuery } from 'shared/hooks';
import { usePrevious } from '../usePrevious/usePrevious';

const defaultPage = 1;

export const useArtifacts = ({
  getArtifactsAction,
  getArtifactsDataActionParams,
  query,
  customLimit,
  ref,
  useUrlParam = false,
  filters,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [localStatePage, setLocalStatePage] = useState(1);
  const { page } = useQuery();
  const { entityId } = useParams();

  const [limit, setLimit] = useState(customLimit || 6);
  const newsFeedPreferencesIsPending = useSelector(getNewsFeedPreferencesIsPending);
  const newsFeedShouldRefresh = useSelector(getNewsFeedShouldRefresh);
  const currentPage = useUrlParam ? +page || defaultPage : localStatePage;

  const previousFilters = usePrevious(filters);
  const previousPage = usePrevious(currentPage);

  const getArtifacts = (artifactPage) => {
    dispatch(
      getArtifactsAction({
        page: artifactPage,
        filters,
        query,
        limit,
        entityId,
        ...getArtifactsDataActionParams,
      }),
    );
  };

  useEffect(() => {
    const noParamChange = isEqual(filters, previousFilters) && isEqual(currentPage, previousPage);

    if (newsFeedPreferencesIsPending || noParamChange) {
      return;
    }

    getArtifacts(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, limit, filters, currentPage, newsFeedPreferencesIsPending]);

  // TODO refreshing should be handled by saga
  useEffect(() => {
    if (newsFeedPreferencesIsPending) {
      return;
    }

    if (newsFeedShouldRefresh) {
      getArtifacts(currentPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsFeedShouldRefresh, newsFeedPreferencesIsPending]);

  const handleArtifactClick = (itemId) => {
    window.location.href = `/page-one/news/${itemId}`;
  };

  const handleChangeArtifactsPage = (e, value) => {
    if (useUrlParam) {
      navigate(`/?page=${value}`);
    } else {
      setLocalStatePage(value);
    }
    scrollToRef(ref);
  };

  const handleChangeRowsPerPage = (e) => {
    setLimit(e.target.value);
  };

  return {
    limit,
    handleChangeArtifactsPage,
    handleArtifactClick,
    handleChangeRowsPerPage,
    currentPage,
  };
};
